export default "__VITE_ASSET__CIy6egS4__"